import PinIconSVG from '../../assets/icons/pin.svg';
export const PinIcon = () => <PinIconSVG style={{ width: '1rem', height: '1rem' }}/>;
